export default "__VITE_ASSET__BFzBJuLF__"